import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

export type CrewContractColumnType = 'EARNING' | 'DEDUCTION' | 'INFO';
export type CrewContractDataType = 'DECIMAL' | 'INTEGER';

export interface CrewContractColumn {
  id: number;
  code: string;
  name: string;
  columnType: CrewContractColumnType;
  dataType: CrewContractDataType;
  includeInTotal: boolean;
  sortOrder: number;
  isActive: boolean;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
}

export const useCrewWageColumns = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<CrewContractColumn> | CrewContractColumn[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<CrewContractColumn>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useCrewWageColumn = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CrewContractColumn>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
